"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ControlRendererContext_1 = __importDefault(require("../../../ControlRendererContext"));
const ControlRenderer_1 = __importDefault(require("../../../ControlRenderer"));
const TransitionRenderer_1 = __importDefault(require("../TransitionRenderer"));
const executeTransition_1 = __importDefault(require("../../../shared/executeTransition"));
const ApplicationContext_1 = __importDefault(require("../../../PageBooter/ApplicationContext"));
const styles = {
    backgroundWrapper: {
        width: '100%',
        height: '100%',
        position: 'absolute',
        backgroundColor: '#1a2b3459',
    },
    controlTrasition: {
        width: '100%',
        height: '100%',
    },
    background: {
        width: '100%',
        height: '100%',
        position: 'absolute',
        top: 0,
    },
};
const SideMenuWrapperRenderer = () => {
    const { Render, functions: { processor } } = (0, react_1.useContext)(ControlRendererContext_1.default);
    const { sideMenuContext, sideMenu } = (0, react_1.useContext)(ApplicationContext_1.default);
    const transitionMenu = (0, react_1.useMemo)(() => {
        if (sideMenuContext === null || sideMenuContext === void 0 ? void 0 : sideMenuContext.transition) {
            return ({
                type: sideMenuContext.transition,
                speed: sideMenuContext.speed,
            });
        }
        return undefined;
    }, [sideMenuContext === null || sideMenuContext === void 0 ? void 0 : sideMenuContext.transition, sideMenuContext === null || sideMenuContext === void 0 ? void 0 : sideMenuContext.speed]);
    const transitionWrapper = (0, react_1.useMemo)(() => {
        if (sideMenuContext === null || sideMenuContext === void 0 ? void 0 : sideMenuContext.transition) {
            return ({
                type: sideMenuContext.transition === 'SlideRight' ? 'FadeIn' : 'FadeOut',
                speed: 'Regular',
            });
        }
        return undefined;
    }, [sideMenuContext === null || sideMenuContext === void 0 ? void 0 : sideMenuContext.transition]);
    const handleSideMenuRequestClose = (0, react_1.useCallback)(() => {
        if ((sideMenuContext === null || sideMenuContext === void 0 ? void 0 : sideMenuContext.transition) && (sideMenuContext === null || sideMenuContext === void 0 ? void 0 : sideMenuContext.speed)) {
            processor.root.setTransitionSideMenu({
                type: 'SlideRightOut',
                speed: sideMenuContext.speed,
            });
            (0, executeTransition_1.default)(sideMenuContext.speed)
                .then(() => processor.root.setIsSideMenuOpened(false));
        }
        else {
            processor.root.setIsSideMenuOpened(false);
        }
        processor.root.isSideMenuOpened = false; // eslint-disable-line
    }, [processor, sideMenuContext === null || sideMenuContext === void 0 ? void 0 : sideMenuContext.transition, sideMenuContext === null || sideMenuContext === void 0 ? void 0 : sideMenuContext.speed]);
    if (!(sideMenuContext === null || sideMenuContext === void 0 ? void 0 : sideMenuContext.isOpened) || !sideMenu) {
        return null;
    }
    return (react_1.default.createElement(TransitionRenderer_1.default, { transition: transitionWrapper, style: styles.backgroundWrapper },
        react_1.default.createElement(TransitionRenderer_1.default, { transition: transitionMenu, style: styles.controlTrasition },
            react_1.default.createElement(Render.TouchableOpacity, { onPress: handleSideMenuRequestClose, style: styles.background }),
            react_1.default.createElement(ControlRenderer_1.default, { control: sideMenu }))));
};
exports.default = SideMenuWrapperRenderer;
